import { render, staticRenderFns } from "./edit_questionnaire.vue?vue&type=template&id=c8731e70&scoped=true&"
import script from "./edit_questionnaire.vue?vue&type=script&lang=js&"
export * from "./edit_questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./edit_questionnaire.vue?vue&type=style&index=0&id=c8731e70&scoped=true&lang=scss&"
import style1 from "./edit_questionnaire.vue?vue&type=style&index=1&id=c8731e70&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8731e70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangenlong/vhall/saas-sdk-questionnaire/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8731e70')) {
      api.createRecord('c8731e70', component.options)
    } else {
      api.reload('c8731e70', component.options)
    }
    module.hot.accept("./edit_questionnaire.vue?vue&type=template&id=c8731e70&scoped=true&", function () {
      api.rerender('c8731e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/edit_questionnaire.vue"
export default component.exports